import { objectSchema } from "vue-utils"
import { UserTimeStamp } from "./UserTimeStamp"

export interface DocumentUpload {
	fileName: string
	mimeType: string
	guid: string
	fileSize: number
	uploadedBy: UserTimeStamp
}

export const DocumentUpload = objectSchema<DocumentUpload>({
	fileName: String,
	mimeType: String,
	guid: String,
	fileSize: Number,
	uploadedBy: UserTimeStamp,
})
